/* eslint-disable consistent-return */
import axios from 'axios'

import { settings } from '../../main/configs/settings'

export default class HelperCitySearch {
  static apiKey = settings.GOOGLE_API_KEY

  static geoNamesUsername = settings.GEONAMES_USERNAME

  static async getCitiesWithinDistance(cities: string[]): Promise<string[]> {
    const promises = cities.map(async (city) => {
      try {
        const geoResponse = await axios.get(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            city,
          )}&key=${HelperCitySearch.apiKey}`,
        )

        const location = geoResponse.data.results[0]?.geometry?.location

        if (location) {
          const nearbyCitiesResponse = await axios.get(
            `https://secure.geonames.org/findNearbyPlaceNameJSON?lat=${location.lat}&lng=${location.lng}&radius=150&maxRows=50&cities=cities15000&username=${HelperCitySearch.geoNamesUsername}`,
          )

          const nearbyCities = nearbyCitiesResponse.data.geonames.map(
            (result: { name: string }) => result.name,
          )

          return nearbyCities
        }
      } catch (error: any) {
        console.error(`Erro ao processar ${city}: ${error.message}`)
        return []
      }
    })

    const results = await Promise.all(promises)

    const citiesWithinDistance = results.flat()

    return citiesWithinDistance
  }
}
